import React from 'react';
import { Icon } from 'antd';
import { useNavigate } from "react-router-dom";
import './Dashboard.less';


type Props = {
    websiteGuid: string;
    contentOverview: string;
    keyPageGroups: {
        guid: string;
        title: string;
        description: string;
        top_issues: {
            title: string;
            seo_test_key: string;
        }[];
    }[];
};


export default function PageGroupInsights({ websiteGuid, contentOverview, keyPageGroups }: Props) {
    const navigate = useNavigate();

    return (
        <>
            <div className="content-overview">
                <h4>Content Overview</h4>
                <p dangerouslySetInnerHTML={{ __html: contentOverview }} style={{ lineHeight: "22px" }}></p>
            </div>

            <div className="top-page-groups">
                <h4>Top page groups</h4>
                {keyPageGroups.map((pageGroup, index) => (
                    <div
                        key={index}
                        className="page-group-overview"
                    >
                        <div className="detail">
                            <div className="title">{pageGroup.title}</div>
                            <div className="description">{pageGroup.description}</div>
                        </div>
                        {pageGroup.top_issues.length > 0 ? (
                            <div className="top-issues">
                                Top issues:
                                <ul>
                                    {pageGroup.top_issues.map((issue, index) => (
                                        <li
                                            key={index}
                                            className="item"
                                        >
                                            <Icon type="stop" />
                                            <span className="link" onClick={() => navigate(`/deep-analysis/failed-check/${issue.seo_test_key}?w_guid=${websiteGuid}&cluster_guid=${pageGroup.guid}`)}>{issue.title}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                ))}
            </div>

        </>
    );
}
